const SanctionAuthority = {
	US: "US",
	EU: "EU",
	UN: "UN",
	OFAC: "OFAC"
};
export default SanctionAuthority;
